import { render, staticRenderFns } from "./UserCreationForm.vue?vue&type=template&id=46f02284&scoped=true&"
import script from "./UserCreationForm.vue?vue&type=script&lang=js&"
export * from "./UserCreationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f02284",
  null
  
)

export default component.exports